export default __webpack_public_path__ + "static/media/heart.686946c1.svg";